import { render, staticRenderFns } from "./ViewVersion.vue?vue&type=template&id=2be6dfca&scoped=true"
import script from "./ViewVersion.vue?vue&type=script&lang=js"
export * from "./ViewVersion.vue?vue&type=script&lang=js"
import style0 from "./ViewVersion.vue?vue&type=style&index=0&id=2be6dfca&prod&lang=css"
import style1 from "./ViewVersion.vue?vue&type=style&index=1&id=2be6dfca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be6dfca",
  null
  
)

export default component.exports